//@flow strict

function inTwoHours(): Date {
	const date=new Date();
	date.setTime(date.getTime()+2*60*60*1000);
	return date;
}

export default inTwoHours;